'use client'
import BlogList from "@/components/Blogs/BlogList";
import React, { useEffect, useState } from "react";
import { Pagination, Spin } from "antd";
import type { Blog } from "@/lib/@types/api/blog";
import { getBlogList } from "@/lib/api/blog";


const  Blogs= ({locale,search}:{locale:string,search:string})=> {
	 const [blogList,setBlogList]=useState<Blog.BlogListItem[]>([])
	const [count,setCount]=useState(3)
	const [pageSize,setPageSize]=useState(1)
	const [searchLoading,setSearchLoading]=useState(false)
	const limit = 6;

	const   fetchBlogList=async (Params:Blog.GetBlogListParams): Promise<{blogList: Blog.BlogListItem[] ,blogCount:number}>=> {
		setSearchLoading(true)
		try {
			const res = await getBlogList(Params);
			setSearchLoading(false)
			return { blogList: res.detail.blog_list ,blogCount:res.detail.blog_filter_count };
		} catch (error) {
			setSearchLoading(false)
			console.error("Error fetching blog list:", error);
			return { blogList: [] ,blogCount:0 }; // 如果发生错误，返回一个空数组
		}
	}
const handlePageChange=(size:number)=>{
	if(size!==pageSize){
		setPageSize(size)
	}
}
	// // 从 API 获取博客列表和分类
	useEffect(() => {
 fetchBlogList({
			lang_code: { lang_code:locale },
			page:pageSize,
			limit,
			blog_title:search||""
		}).then(res=>{
			if(res){
				setBlogList(res.blogList)
				setCount(res.blogCount)
			}
 })
	}, [pageSize]);

	return <div className="left xl:w-3/4 xl:pr-2 flex justify-center ">
		{searchLoading ?     <Spin size="large" /> :
		<section>
			<BlogList blogList={blogList} />
			{count > 1 && (
				<div className="list-pagination w-full flex items-center md:mt-10 mt-6">
					<Pagination current={pageSize} total={count} pageSize={limit} onChange={handlePageChange} />
				</div>
			)
			}
		</section>
		}
	</div>
}
export  default  React.memo(Blogs)
